import { useNavigate } from "react-router-dom";
import { sessionStorageKeys } from "../../config/config";

export function useChatNavigate() {
  const navigate = useNavigate();

  const gotoChat = ({
    sessionId,
    questionId,
  }: {
    sessionId: string;
    questionId?: string;
  }) => {
    sessionStorage.setItem(sessionStorageKeys.sessionKey, sessionId);
    if (questionId) {
      sessionStorage.setItem(sessionStorageKeys.questionKey, questionId);
    } else {
      sessionStorage.removeItem(sessionStorageKeys.questionKey);
    }
    if (sessionId && questionId) {
      navigate(
        `/spend-wise-hub/chat-assistant/${sessionId}?questionId=${questionId}`
      );
    } else if (sessionId) {
      navigate(`/spend-wise-hub/chat-assistant/${sessionId}`);
    }
  };
  return {
    gotoChat,
  };
}
